import Box from '@mui/material/Box';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useEffect, useMemo, useState } from 'react';
import { useStore } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import ReactRouter7Adapter from 'util/ReactRouter7Adapter';
import Footer from '../../components/Footer';
import Initialize from '../../components/Initialize';
import NavigationBar from '../../components/NavigationBar';
import { MODULE_PRIORITY } from '../../domain/modules';
import { selectors as configurationSelectors } from '../../ducks/configurationDuck';

const ModuleRedirectHandler = () => {
  const store = useStore();
  const [doRedirect, setDoRedirect] = useState(false);
  const location = useLocation();
  const modules = useMemo(() => {
    return configurationSelectors.modules(store.getState()) || [];
  }, [store]);
  const module = MODULE_PRIORITY.find(moduleItem => modules.includes(moduleItem.key));
  useEffect(() => {
    const timeout = setTimeout(() => {
      // Set timeout to prevent redirect loop and let router load
      setDoRedirect(true);
    }, 200);
    return () => clearTimeout(timeout);
  }, []);
  if (doRedirect && location.pathname === '/' && module) {
    return <Navigate to={module.path} replace />;
  } else if (doRedirect && location.pathname === '/') {
    return <Navigate to={'/settings'} replace />;
  } else {
    return null;
  }
};

const AppWrapper = () => {
  return (
    <QueryParamProvider adapter={ReactRouter7Adapter}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <NavigationBar />
        <Initialize>
          <ModuleRedirectHandler />
          <Box sx={{ display: 'flex' }}>
            <Box
              component="main"
              sx={{
                zIndex: 0,
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                width: '100vw',
                pt: 8,
                pb: '40px',
              }}
            >
              <Outlet />
              <Footer />
            </Box>
          </Box>
        </Initialize>
      </LocalizationProvider>
    </QueryParamProvider>
  );
};

export default AppWrapper;
